// extracted by mini-css-extract-plugin
export default {"wrapper":"Singers_wrapper__igAe3"};